module.exports = __webpack_public_path__ + "static/media/remove_budget_icon_reimbursement.ade01531.svg";